import { render, staticRenderFns } from "./view-tweets.vue?vue&type=template&id=6eb9beff"
import script from "./view-tweets.vue?vue&type=script&lang=js"
export * from "./view-tweets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports